import callApi from '../../util/apiCaller';
import { getFileUrl } from '../../util/file';

import { getDefaultPriceValues } from './CreditActions';
import { getLoggedUser } from '../User/UserActions';
import { subscribeToChannel, setIsFetching, getItemsRequest } from '../App/AppActions';
import { addError } from '../Error/ErrorActions';

// Export Constants
export const SET_INSTITUTIONS = 'SET_INSTITUTIONS';
export const SET_INSTITUTION_LOGO = 'SET_INSTITUTION_LOGO';
export const SET_ACTIVE_INSTITUTION = 'SET_ACTIVE_INSTITUTION';

export function getInstitutionsRequest(needSubscribe = false) {
    return dispatch => dispatch(getItemsRequest('institutions', null, items => {
        dispatch(setInstitutions(items));
        items.forEach(institution => {
            items.length < 10 && dispatch(setInstitutionLogoUrlRequest(institution)); // Do not fetch all logo for root users (more than ~10 institutions)
            needSubscribe && dispatch(subscribeToChannel(`institution/${institution._id}`));
        });
    }, null, { isRecursive: true }));

    // return dispatch => {
    //     dispatch(setIsFetching('institutions'));
    //     return callApi('institutions').then(result => {
    //         if(result.institutions) {
    //         }
    //         return result.institutions;
    //     }).catch(err => {
    //         return null;
    //     });
    // };
}

export function getInstitutionRequest(institutionId) {
    return dispatch => {
        dispatch(setIsFetching('institutions'));
        return callApi(`institution/${institutionId}`).then(result => {
            dispatch(setInstitutions([result.institution]));
            return result.institution;
        }).catch(err => {
            return null;
        });
    };
}

export function editInstitutionRequest(institution, options = {}) {
    return dispatch => {
        return callApi('institution/edit', 'post', { institution, options }).then(result => {
            result && result.institution && dispatch(getInstitutionRequest(result.institution._id));
            return result.institution;
        }).catch(err => {
            if(err.message === 'InstitutionAlreadyExists') {
                dispatch(addError(err.message));
            }
            return null;
        });
    };
}

export function removeInstitutionRequest(institutionId) {
    return dispatch => {
        return callApi('institution/remove', 'delete', { institution: { _id: institutionId } }).then(result => {
            dispatch(getInstitutionsRequest());
            return result.ok;
        }).catch(err => {
            return null;
        });
    };
}

export function setInstitutionLogoUrlRequest(institution) {
    return dispatch => {
        if(institution.logoPath) {
            return getFileUrl(institution.logoPath, null, null, true).then(fileUrl => {
                dispatch(setInstitutionLogoUrl(institution._id, fileUrl));
                return fileUrl;
            });
        }
        return Promise.resolve(null);
    };
}

export function getWebserviceInitRequest(type, webserviceData = []) {
    return callApi(`institution/webservice/${type}/init`, 'POST', { webserviceData }).then(result => {
        return result?.data;
    });
}

// Getters
export function getInstitution(store, id) {
    return store.institutions.data.find(institution => institution._id === id);
}

export function getActiveInstitution(store) {
    return store.institutions.activeInstitution;
}

export function getActiveInstitutions(store) {
    if(getLoggedUser(store)) {
        if(getActiveInstitution(store)) {
            return [getActiveInstitution(store)];
        }
        return store.institutions.data;
    }
    return [];
}

export function getInstitutions(store) {
    return store.institutions.data.sort((institutionA, institutionB) => institutionA.name.localeCompare(institutionB.name));
}

export function getInstitutionsForLoggedUser(store) {
    const loggedUser = getLoggedUser(store);
    const allInstitutions = getInstitutions(store);
    const sorter = (institutionA, institutionB) => institutionA.name.localeCompare(institutionB.name);
    if(loggedUser && loggedUser.institutions && loggedUser.institutions.length) {
        if(loggedUser.institutions.includes('*')) {
            return allInstitutions.sort(sorter);
        }
        return loggedUser.institutions.map(institutionId => allInstitutions.find(institution => institution._id === institutionId)).filter(institution => institution).sort(sorter);
    }
    return [];
}

export function getInstitutionPreference(institution, preference) {
    return (institution && institution.preferences && institution.preferences[preference]) || '';
}

export function getInstitutionContact(institution, type, field = 'email') {
    return (institution && institution.contacts && institution.contacts[type] && institution.contacts[type][field]) || '';
}

export function getWebserviceTypes() {
    return ['generic', 'moodle', 'lti'];
}

export function getWebserviceData(webservice, key) {
    return (webservice.data.find(data => data.key === key) || {}).value || '';
}

export function isHookAvailable(webserviceOrType) {
    return ['generic', 'moodle', 'lti'].includes(webserviceOrType.type || webserviceOrType);
}

export function getWebserviceHooks() {
    return ['sessionCorrectionValidation', 'sessionEdition', 'sessionPublication', 'sessionExport', 'applicantUpdate', 'applicantFlag', 'applicantValidation'];
}

export function getWebserviceOption(webservice, option) {
    return (webservice && webservice.options && webservice.options[option]) || '';
}

export function getDefaultPricing() {
    const priceDefaultValues = getDefaultPriceValues();
    return Object.keys(priceDefaultValues).map(type => {
        return {
            type,
            value: priceDefaultValues[type],
        };
    });
}

// Export Actions
export function setInstitutions(institutions) {
    return {
        type: SET_INSTITUTIONS,
        institutions,
    };
}

export function setInstitutionLogoUrl(institutionId, logoUrl) {
    return {
        type: SET_INSTITUTION_LOGO,
        institutionId,
        logoUrl,
    };
}

export function setActiveInstitution(activeInstitution) {
    return {
        type: SET_ACTIVE_INSTITUTION,
        institution: activeInstitution,
    };
}
